// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import { v4 as uuidv4 } from 'uuid';

import {
  SIMULADOR_FINANCIERO_ADD_AUTO,
} from './constants';

export function addAuto(auto) {
  return {
    type: SIMULADOR_FINANCIERO_ADD_AUTO,
    data: auto
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_ADD_AUTO:
      let data = {...action.data};
      let auto = {
        id: uuidv4(),
        data: data,
        newLinea: true
      }
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        let existe = false;
        editLineaData.asignacionLineas.lineas.forEach((linea) => {
          if (linea.data.idBrand === auto.data.idBrand && linea.data.idModel === auto.data.idModel && linea.data.idVersion === auto.data.idVersion) {
            existe = true;
          }
        })
        if (!existe) {
          editLineaData.asignacionLineas.lineas.push(auto);
        }
        
        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let existe = false;
        altaNuevaLinea.asignacionLineas.lineas.forEach((linea) => {
          if (linea.data.idBrand === auto.data.idBrand && linea.data.idModel === auto.data.idModel && linea.data.idVersion === auto.data.idVersion) {
            existe = true;
          }
        })
        if (!existe) {
          altaNuevaLinea.asignacionLineas.lineas.push(auto);
        }
        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }

    default:
      return state;
  }
}
